
export default {
  props: {
    url: { type: String, required: false, default: undefined },
    size: { type: String, required: false, default: undefined },
  },
  data() {
    return {
      showPlay: true,
      videoId: '',
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 0,
        loop: 0,
        rel: 0,
        fs: 1,
        showinfo: 0,
        autohide: 0,
        controls: 1,
        modestbranding: 1,
      },
    }
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    },
  },
  mounted() {
    this.videoId = this.getId(this.url)
  },
  methods: {
    playVideo() {
      this.player.playVideo()
      this.showPlay = false
    },
    getId(url) {
      return this.$youtube.getIdFromUrl(url)
    },
    paused() {
      this.showPlay = true
    },
    playing() {
      this.showPlay = false
    },
  },
}
